import { Injectable } from '@angular/core';
import { BaseService } from '../infra/base-service';
import {
  RequestSalvarStatusUsuario,
  ResponseListarUsuarios,
  Usuario,
} from '../interfaces/usuario/usuario.interface';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import {
  RequestSalvarPermissoes,
  ResponsePermissoesUsuario,
} from '../interfaces/usuario/permissao.interface';
import { EnumOrdenacaoUsuario } from '../enums/ordenacao-usuario.enum';

@Injectable({
  providedIn: 'root',
})
export class UsuarioService extends BaseService {
  constructor(http: HttpClient, toastr: ToastrService) {
    super(http, toastr);
  }

  obterDadosUsuarioLogado(): Promise<Usuario> {
    return this.get<Usuario>('usuario/obterdadosusuariologado');
  }

  buscarUsuarios(
    pagina: number,
    quantidade: number,
    ordenacao: EnumOrdenacaoUsuario,
    filtro: string
  ): Promise<ResponseListarUsuarios> {
    return this.get<ResponseListarUsuarios>('usuario/listar', {
      pagina,
      quantidade,
      ordenacao,
      filtro,
    });
  }

  salvarPermissoesUsuario(request: RequestSalvarPermissoes): Promise<void> {
    return this.post('usuario/salvarpermissoes', request);
  }

  alterarStatusUsuario(request: RequestSalvarStatusUsuario): Promise<string> {
    return this.post<string>('usuario/salvarstatus', request);
  }

  salvarUsuario(request: Usuario): Promise<string> {
    return this.post('usuario/salvar', request);
  }

  verificarEmailExistente(email: string, idUsuario: number): Promise<boolean> {
    const encodedEmail = encodeURIComponent(email);
    return this.get<boolean>(
      `usuario/verificaremail?email=${encodedEmail}&idUsuario=${idUsuario}`
    );
  }

  alterarSenha(senhaAtual: string, novaSenha: string): Promise<void> {
    return this.post(
      `usuario/alterarsenha?senhaAtual=${senhaAtual}&novaSenha=${novaSenha}`,
      {}
    );
  }
}
